import * as Sentry from '@sentry/remix';

import { ensurePixelIsLoaded } from '~/utils/pixels';

async function fireEvent(eventId: string, data?: unknown) {
  try {
    await ensurePixelIsLoaded('twq');

    window.twq('event', eventId, data);
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire Twitter pixel event' }
    });
  }
}

const EventIds = {
  AddToCart: 'tw-o0ec0-odmpm',
  AddToCartAF: 'tw-o0ec0-ogb5w',
  CompletePayment: 'tw-o0ec0-odmp5',
  CompleteRegistration: 'tw-o0ec0-ogcll',
  InitiateCheckout: 'tw-00ec0-odmpd',
  NotifyMeSet: 'tw-o0ec0-oggkc',
  PageView: 'tw-o0ec0-odnmz',
  ViewContent: 'tw-o0ec0-odmp8'
};

export default {
  EventIds,
  fireEvent
};
